import MetaHead from '@/Components/MetaHead';
const { parse } = require('rss-to-json');


// const fetchMediumBlogUrl = 'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@nirmaldev81';
const fetchMediumBlogUrl = 'https://medium.com/feed/@fyllotech';
export default function Blog({ Blog, id }) {
  return (
    <main className="py-8 px-4 mx-auto max-w-screen-lg text-left lg:py-16 lg:px-6 ">
      <MetaHead title={Blog.title + ' | Fyllo'} keywords={Blog.categories?.join(',')} description={Blog.title}/>
      <div className="mx-auto ">
        <h2 className="text-fyllo-800 mb-4 md:mb-8 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-4xl  text-center">
          {Blog.title}
        </h2>
        <p className=" mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl  text-center">
          {/* We have researched and worked on 20+ crops across horticulture, plantation , fibres and agriculture. We have
                    100+ models for precise irrigation, fertigation and disease and pest models. */}
        </p>
      </div>

      <div
        className="mx-auto max-w-screen-lg p-2 prose prose-sm prose-stone lg:prose-xl prose-img:rounded-xl prose-headings:text-gray-700 prose-headings:font-bold  prose-a:text-blue-600"
        dangerouslySetInnerHTML={{
          __html: Blog.description,
        }}
      ></div>
    </main>
  );
}

// export async function getStaticPaths() {
//   const response = await fetch(fetchMediumBlogUrl);
//   const Blogs = (await response.json())?.items;

//   const ways = Blogs.map((it) => {
//     return {
//       params: { blogId: it.title },
//     };
//   });

//   return {
//     paths: ways,
//     fallback: false,
//   };
// }

// export async function getStaticProps({ params }) {
//   const response = await fetch(fetchMediumBlogUrl);
//   const Blogs = (await response.json())?.items;

//   const id = params.blogId;
//   let Blog = Blogs.find((it) => id === it.title) ?? {};

//   return {
//     props: { Blog, id },
//     revalidate: 60,
//   };
// }

export async function getServerSideProps({ params }) {
  const response = await parse(fetchMediumBlogUrl, {
    headers: {
     'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/110.0.0.0 Safari/537.36'
    }
 })

  const blogs = (response?.items || []).map(blog => ({
    ...blog,
    title: blog.title,
    description: blog?.description || blog?.content || "",
}));
  
  const id = params.blogId;
  let Blog = blogs.find((it) => id === it.title) ?? {};

  return {
    props: { Blog, id },
  };
}